'use strict';

var tslib_es6 = require('../../_virtual/tslib.es6-20bd5fbf.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Basic button component
 */
const Button = (_a) => {
    var { children, className, href, text, secondary, square, light, fullwidth } = _a, rest = tslib_es6.__rest(_a, ["children", "className", "href", "text", "secondary", "square", "light", "fullwidth"]);
    const classes = [
        'wds-button',
        className,
        secondary ? 'wds-is-secondary' : '',
        square ? 'wds-is-square' : '',
        light ? 'wds-is-light' : '',
        text ? 'wds-is-text' : '',
        fullwidth ? 'wds-is-fullwidth' : '',
    ]
        .filter((c) => c)
        .join(' ');
    if (href) {
        return (React__default["default"].createElement("a", Object.assign({ href: href, className: classes }, rest), children));
    }
    return (React__default["default"].createElement("button", Object.assign({ className: classes }, rest), children));
};

module.exports = Button;
